import type { HubState } from '../state';
import type { AppState, ContactFolder } from '../../appstate';
import { getCurrentHubPersona } from './currentPersonaSelector';
import { getPublicFolderForCurrentHubPersona } from './publicFolderSelector';
import {
    HubPersona,
    PublicDistributionList,
    createSelector,
    PersonType,
    PrivateDistributionList,
} from '../../shared';
import { comparePrivateDLMembers } from '../utils/personaSorting';

/**
 * Returns the DL currently in focus with sorted members.
 * If multiple personas, or a person is in focus, undefined is returned.
 */
export const getCurrentDistributionList = createSelector<
    AppState,
    HubState,
    HubPersona,
    string,
    ContactFolder,
    PublicDistributionList | PrivateDistributionList
>(
    'getCurrentDistributionList',
    [
        getCurrentHubPersona,
        (appState: AppState, _hubState: HubState) =>
            appState.data.userConfiguration.settings.UserCulture,
        getPublicFolderForCurrentHubPersona,
    ],
    (currentPersona, culture, publicFolder) => {
        const publicFolderId = publicFolder?.id;

        if (
            currentPersona &&
            (currentPersona.type === PersonType.PrivateDistributionList ||
                currentPersona.type === PersonType.PublicDistributionList)
        ) {
            if (currentPersona.members) {
                const sortedMembers = [...currentPersona.members].sort(
                    comparePrivateDLMembers(culture)
                );
                return {
                    ...currentPersona,
                    publicFolderId,
                    members: sortedMembers,
                };
            }

            return { ...currentPersona, publicFolderId };
        }

        return undefined;
    }
);
